<div class="page-wrapper">
  <div class="page-header d-print-none">
    <div class="container-xl">
      <div class="row g-2 align-items-center">
        <div class="col">
          <div class="page-pretitle">Gestión</div>
          <h2 class="page-title">Notificaciones</h2>
        </div>
      </div>
    </div>
  </div>
  <div class="page-body">
    <div class="container-xl">
      @if (isLoading) {
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body text-center py-4">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Cargando...</span>
                </div>
                <p class="mt-2">Cargando notificaciones...</p>
              </div>
            </div>
          </div>
        </div>
      } @else {
        <div class="row">
          <div class="col-12">
            <app-notifications-table 
              [notifications]="notifications"
            />
          </div>
        </div>
      }
    </div>
  </div>
</div>